import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { VirtualSiteGroupEntity } from "src/app/features/VirtualSiteGroup/types/VirtualSiteGroupEntity";
import { TextInput } from "../../../../../components/Form/formComponents";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const VirtualSiteGroupSearchForm: FC<SearchFormProps<VirtualSiteGroupEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();

    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("virtualSiteGroupSearchForm.criteriaBadges.id")} name="id">
                <TextInput name="id" />
            </Form.Item>
            <Form.Item label={t("virtualSiteGroupSearchForm.criteriaBadges.name")} name="name">
                <TextInput name="name" />
            </Form.Item>
            <Form.Item label={t("virtualSiteGroupSearchForm.criteriaBadges.priority")} name="priority">
                <TextInput name="priority" />
            </Form.Item>
        </SearchForm>
    );
};
